import { DEFAULT_LOCALE } from '../_constants';
import { isValidLocale } from './is-valid-locale';
export var sanitizeLocale = function (locale) {
    return isValidLocale(locale) ? locale : DEFAULT_LOCALE;
};
